import API from "./lib/api";

export const getAllSpendGetDiscountOffersApi = async (restaurant_id, query = "") => {
  try {
    const { data } = await API.get(
      `restaurant/${restaurant_id}/spend-and-get-discount-offers?${query}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleSpendGetDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.get(
      `restaurant/spend-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const addSpendGetDiscountOfferApi = async (offerData) => {
  try {
    const { data } = await API.post(
      `restaurant/spend-and-get-discount-offers`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const editSpendGetDiscountOfferApi = async (offerData, id) => {
  try {
    const { data } = await API.put(
      `restaurant/spend-and-get-discount-offers/${id}`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteSpendGetDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.delete(
      `restaurant/spend-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleSpendGetDiscountOfferStatusApi = async (id) => {
  try {
    const { data } = await API.put(
      `restaurant/spend-and-get-discount-offers/${id}/toggle-status`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
